import cloneDeep from "lodash-es/cloneDeep";

/**
 * @description
 * Returns a copy of the object with all empty properties removed.
 * @param {Record<string, any>} object
 */
export default (object: Record<string, any>) => {
  const filteredObject = cloneDeep(object);

  for (const [key, value] of Object.entries(object)) {
    if (value === "" || value === null || value === undefined) {
      delete filteredObject[key];
    }
  }

  return filteredObject;
};
